import { Check } from "lucide-react";
import { PRICING } from "@/data/content";
import { Reveal } from "./Reveal";

export const Pricing = () => (
  <section id="pricing" className="relative border-t border-white/10 py-28 md:py-40" data-testid="pricing">
    <div className="ec-container">
      <Reveal className="mb-16 text-center">
        <p className="ec-eyebrow mb-4 justify-center">
          <span className="h-1.5 w-1.5 rounded-full bg-[#D4F870]" />
          FİYATLAR
        </p>
        <h2 className="mx-auto max-w-2xl font-display text-4xl leading-[1.02] tracking-tight text-[#F3F4F6] sm:text-5xl md:text-6xl">
          Ölçeğine göre planla.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {PRICING.map((p, i) => (
          <Reveal key={p.name} delay={i * 0.08}>
            <div
              className={`relative flex h-full flex-col rounded-2xl border p-8 transition-transform duration-300 hover:-translate-y-1 ${
                p.featured
                  ? "border-[#D4F870]/50 bg-[#121212] ec-glow"
                  : "border-white/8 bg-[#0F0F0F]"
              }`}
              data-testid={`pricing-${i}`}
            >
              {p.featured && (
                <span className="absolute right-6 top-6 rounded-full bg-[#D4F870] px-3 py-1 text-[10px] font-medium uppercase tracking-widest text-[#0A0A0A]">
                  Popüler
                </span>
              )}
              <h3 className="font-display text-2xl text-[#F3F4F6]">{p.name}</h3>
              <div className="mt-4">
                <span className="font-display text-3xl leading-tight text-[#D4F870]">{p.price}</span>
              </div>
              <p className="mt-3 text-sm text-[#9CA3AF]">{p.desc}</p>
              <ul className="mt-8 flex-1 space-y-3">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm text-[#F3F4F6]">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#D4F870]" />
                    {f}
                  </li>
                ))}
              </ul>
              <a
                href="/pricing"
                className={`mt-8 inline-flex items-center justify-center rounded-full px-6 py-3 text-sm font-medium transition-colors ${
                  p.featured
                    ? "bg-[#D4F870] text-[#0A0A0A] hover:bg-[#BEF264]"
                    : "border border-white/15 text-[#F3F4F6] hover:border-white/40"
                }`}
                data-testid={`pricing-cta-${i}`}
              >
                {p.cta}
              </a>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
